import { ComponentPropsWithoutRef } from "react";
import Tooltip from "../ui/Tooltip";
import Icon from "components/Icon";
import styles from "./Label.module.css";

type LabelProps = ComponentPropsWithoutRef<"label"> & {
  required?: boolean;
  tooltipContent?: string;
  underDevelopment?: boolean;
};

export default function Label({
  children,
  required,
  tooltipContent,
  underDevelopment,
  className = "",
  ...props
}: LabelProps) {
  const isHtmlString = typeof children === "string";

  const hasIcon = underDevelopment || tooltipContent;

  return (
    <label {...props} className={`${styles.label} ${className}`}>
      {isHtmlString ? (
        // Render HTML
        <span
          className={`${required ? styles.required : ""}`}
          dangerouslySetInnerHTML={{ __html: children as string }}
        />
      ) : (
        // Render React nodes normally
        <span className={`${required ? styles.required : ""}`}>{children}</span>
      )}

      {/* Icons */}
      {hasIcon && (
        <span className={styles.iconSlot}>
          {underDevelopment && (
            <Tooltip content={<p>Under Construction</p>}>
              <Icon
                name="construction"
                iconAs="icon"
                size={15}
                style={{ marginLeft: 5 }}
              />
            </Tooltip>
          )}

          {tooltipContent && (
            <Tooltip
              content={
                <p dangerouslySetInnerHTML={{ __html: tooltipContent }} />
              }
            >
              <Icon
                name="info"
                iconAs="icon"
                size={15}
                style={{ marginLeft: 5 }}
              />
            </Tooltip>
          )}
        </span>
      )}
    </label>
  );
}
